import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Phone, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";

export const ServiceCTA = ({
  title = "Ready to book your clean?",
  description = "Get a tailored quote within 24 hours, or call our London team now.",
  variant = "navy",
}) => {
  const isLight = variant === "light";

  return (
    <section
      className={`py-16 md:py-24 ${isLight ? "bg-slate-50" : "bg-navy"}`}
      data-testid="service-cta-section"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className={`max-w-4xl mx-auto rounded-2xl p-8 md:p-12 ${
            isLight
              ? "bg-navy text-white"
              : "bg-white/5 backdrop-blur border border-white/10 text-white"
          }`}
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div className="max-w-xl">
              <h2 className="font-heading text-3xl md:text-4xl font-semibold mb-3">
                {title}
              </h2>
              <p className="text-slate-300 leading-relaxed">{description}</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/get-a-quote">
                <Button
                  size="lg"
                  className="bg-gold hover:bg-gold-dark text-navy font-bold px-6 py-6 rounded-xl w-full"
                  data-testid="cta-quote-btn"
                >
                  Get a Quote
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
              <a href="tel:+442080363586">
                <Button
                  size="lg"
                  variant="outline"
                  className="border-white/30 text-white hover:bg-white/10 font-semibold px-6 py-6 rounded-xl w-full"
                  data-testid="cta-call-btn"
                >
                  <Phone className="mr-2 w-4 h-4" />
                  Call Now
                </Button>
              </a>
              <a
                href="https://wa.me/447346006547"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  size="lg"
                  variant="outline"
                  className="border-white/30 text-white hover:bg-white/10 font-semibold px-6 py-6 rounded-xl w-full"
                  data-testid="cta-whatsapp-btn"
                >
                  <MessageCircle className="mr-2 w-4 h-4" />
                  WhatsApp
                </Button>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
